import { LOCAL_STORAGE_STORE_CONSTANTS } from 'constants/general';
import {
    createAccountLogin,
    createAccountLogout,
    createAccountRegister,
    forgotPassword,
    readUserIdByToken,
    resetPassword,
} from 'api/auth';
import { ChangePasswordRequest, SignUpFormData } from 'types/auth';
import mockCall from 'utils/mockCall';

export const loginUser = (email: string, password: string) =>
    createAccountLogin({ email, password }).then((res) => {
        const { token } = res.data;
        localStorage.setItem(
            LOCAL_STORAGE_STORE_CONSTANTS.X_USER,
            JSON.stringify({
                token,
            }),
        );
        return res.data;
    });

export const logoutUser = (id: string) => createAccountLogout({ id }).then(() => true);

export const registerUser = ({ firstName, lastName, email, phoneNumber, password }: SignUpFormData) => {
    const request = {
        email,
        firstName,
        lastName,
        password,
        phoneNumber,
    };
    return createAccountRegister(request).then(({ data }) => data);
};

export const getUserIdByToken = (token: string) => readUserIdByToken(token).then(({ data }) => data);

export const forgotPasswordByEmail = (email: string) => forgotPassword({ email }).then(({ data }) => data);

export const changePassword = (request: ChangePasswordRequest) => resetPassword(request).then(({ data }) => data);
